'use client';
import React from 'react';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { Box, Typography } from '@mui/material';

import { useT } from '@/hooks';

interface EmptyCommentsStateProps {
  title?: string;
  description?: string;
}

export function EmptyCommentsState({ title, description }: EmptyCommentsStateProps) {
  const { t } = useT();

  const finalTitle = title || t('market.noCommentsYet');
  const finalDescription = description || t('market.beFirstToComment');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        color: 'text.secondary',
        textAlign: 'center',
      }}
    >
      <ForumOutlinedIcon sx={{ fontSize: 48, mb: 2, opacity: 0.3 }} />
      <Typography variant="h6" fontWeight={600} gutterBottom sx={{ color: 'text.primary' }}>
        {finalTitle}
      </Typography>
      <Typography variant="body2" sx={{ maxWidth: 250 }}>
        {finalDescription}
      </Typography>
    </Box>
  );
}

export default EmptyCommentsState;
